export const MOBILE_PANEL_DRAG_START_EVENT = 'workspace-mobile-panel-drag-start'

export const notifyMobilePanelDragStart = () => {
  window.dispatchEvent(new CustomEvent(MOBILE_PANEL_DRAG_START_EVENT))
}
